import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import { CerrixInputComponent } from "../../atoms/cerrix-input/cerrix-input.component";
import { CerrixLabelComponent } from "../../atoms/cerrix-label/cerrix-label.component";
import { CerrixInputValidationMaxLengthDirective } from "@app/shared/directives/cerrix-input-fields/cerrix-input-validation-max-length.directive";
import { CerrixInputValidationErrorsDirective } from "@app/shared/directives/cerrix-input-fields/cerrix-input-validation-errors.directive";
import { CerrixInstructionsIconComponent } from "@app/shared/cerrix-instructions-icon/cerrix-instructions-icon.component";

@Component({
    selector: "cerrix-input-group",
    imports: [
        CerrixInputComponent,
        CerrixLabelComponent,
        CerrixInstructionsIconComponent,
        CerrixInputValidationErrorsDirective,
        CerrixInputValidationMaxLengthDirective,
    ],
    templateUrl: "./cerrix-input-group.component.html",
    styleUrl: "./cerrix-input-group.component.scss",
    encapsulation: ViewEncapsulation.None
})
export class CerrixInputGroupComponent {
    @Input() placeholder: string = "";
    @Input() disabled: boolean = false;
    @Input() infoText: string = "";
    @Input() maxLength: number = 300;
    @Input() name: string = "";
    @Input() type: string = "text";
    @Input() value: string = "";
    @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
}
